module.exports = __webpack_public_path__ + "main/assets/public/footer/logo-reversed.178f0c743abf665e.svg";